<template>
  <div class="upload-container">
    <el-button
      :style="{ background: color, borderColor: color }"
      icon="el-icon-upload"
      size="mini"
      type="primary"
      @click="setUp"
    >
      点击此处上传档案
    </el-button>
    <el-dialog :visible.sync="dialogVisible">
      <el-upload
        :data="{ token }"
        :file-list="fileList"
        :show-file-list="true"
        :on-remove="handleRemove"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        class="editor-slide-upload"
        action="https://up.qbox.me"
        list-type="text"
      >
        <el-button size="small" type="primary"> 点击上传 </el-button>
      </el-upload>
      <el-button @click="dialogVisible = false"> 取消 </el-button>
      <el-button type="primary" @click="handleSubmit"> 确定 </el-button>
    </el-dialog>
  </div>
</template>

<script>
import { qiNiuHost } from "@/assets/js/qiniu";

export default {
  name: "upFile",
  props: {
    token: {
        type: String,
        default: ''
    },
    color: {
      type: String,
      default: "#AD2729 ",
    },
  },
  data() {
    return {
      dialogVisible: false,
      listObj: {},
      fileList: [],
    };
  },
  mounted() {

  },
  methods: {
    setUp() {
      if (!this.token) return this.$alert("没有获取到token");
      this.dialogVisible = true;
    },
    checkAllSuccess() {
      return Object.keys(this.listObj).every(
        (item) => this.listObj[item].hasSuccess
      );
    },
    handleSubmit() {
      const arr = Object.keys(this.listObj).map((v) => this.listObj[v]);
      if (!this.checkAllSuccess()) {
        this.$message(
          "请等待文件上传成功！"
        );
        return;
      }
      this.listObj = {};
      this.fileList = [];
      this.dialogVisible = false;
      this.$emit("successCBK", arr);
      
    },
    handleSuccess(response, file) {
      const uid = file.uid;
      const objKeyArr = Object.keys(this.listObj);
      for (let i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          this.listObj[objKeyArr[i]].url = qiNiuHost + response.key;
          this.listObj[objKeyArr[i]].hasSuccess = true;
          return;
        }
      }
    },
    handleRemove(file) {
      const uid = file.uid;
      const objKeyArr = Object.keys(this.listObj);
      for (let i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].uid === uid) {
          delete this.listObj[objKeyArr[i]];
          return;
        }
      }
    },
    beforeUpload(file) {
      const _self = this;
      const _URL = window.URL || window.webkitURL;
      const fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise((resolve, reject) => {
        // const img = new Image();
        // img.src = _URL.createObjectURL(file);
        // img.onload = function () {
          
        // };
        _self.listObj[fileName] = {
            hasSuccess: false,
            uid: file.uid,
            name: file.name,
            type: file.type
          };
        resolve(true);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.editor-slide-upload {
  margin-bottom: 20px;
  ::v-deep .el-upload--picture-card {
    width: 100%;
  }
}
</style>
